document.addEventListener('DOMContentLoaded', function() {

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isMobile = window.innerWidth <= 768;

  if ( document.querySelectorAll('.hompage_main_container_withinit.swiper').length > 0 ){
    document.querySelectorAll('.hompage_main_container_withinit.swiper').forEach((swiperinitilize) => {
      new Swiper(swiperinitilize, {
        spaceBetween: 18,
        mousewheel: {forceToAxis: true,thresholdDelta: 35},
        allowTouchMove: true,freeMode: true,slidesPerView: 'auto',grabCursor: true,
        keyboard: { enabled: true },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        cssMode: isIOS && isMobile ? true : false,
      });
    }); 
  }

  if ( document.querySelectorAll('.customer__testimonial_swipe').length > 0 ){
    const swiperElementCardSwp = document.querySelector('.customer__testimonial_swipe.swiper');
    if (swiperElementCardSwp) {
      const config = {
        spaceBetween: 18,allowTouchMove: true,slidesPerView: 'auto',grabCursor: true,keyboard: { enabled: true },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'}
      };
      if (!isIOS) {
        config.freeMode = true;
        config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
      }
      window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
    }  
  }

  if ( document.querySelectorAll('[data-tab-action]').length > 0 ){
    document.querySelectorAll('[data-tab-action]').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        let tab_name = target.currentTarget.dataset.tabAction;
        document.querySelectorAll('[data-tab-action]').forEach((loopElm)=>{loopElm.classList.remove('active')});
        document.querySelectorAll('[data-tab-visible]').forEach((loopElm)=>{loopElm.classList.remove('active')});
        target.currentTarget.classList.add('active');
        document.querySelector(`[data-tab-visible="${tab_name}"]`).classList.add('active');
        const htab_container = document.querySelector('.homepage_tab_sliderxt');
        const htab_tabRect = target.currentTarget.getBoundingClientRect();
        const htab_containerRect = htab_container.getBoundingClientRect();
        const scrollLeft = htab_container.scrollLeft + (htab_tabRect.left - htab_containerRect.left) - (htab_containerRect.width / 2 - htab_tabRect.width / 2);
        htab_container.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      })
    })
  }

  if( document.querySelectorAll('.play_paused___action .action--pause').length > 0 ){
    document.querySelectorAll('.play_paused___action .action--pause').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('[js-video-container]').querySelector('.action--play').classList.remove('hidden');
        target.target.closest('[js-video-container]').querySelector('video').pause();
      })
    });
    document.querySelectorAll('.play_paused___action .action--play').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('[js-video-container]').querySelector('.action--pause').classList.remove('hidden');
        target.target.closest('[js-video-container]').querySelector('video').play();
      })
    });  
  }

  if( document.querySelectorAll('.scrolling__card_content').length > 0 ){
    const scrollingContent = document.getElementById("marqueeContent");
    scrollingContent.innerHTML += scrollingContent.innerHTML;
    let x = 0;
    let scrollSpeed = 0.4;
    let isPaused = false;
    function animate() {
      if (!isPaused) {
        x -= scrollSpeed;
        if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
          x = 0;
        }
        scrollingContent.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(animate);
    }
    document.querySelector(".scrolling__card_content").addEventListener("mouseenter", () => isPaused = true);
    document.querySelector(".scrolling__card_content").addEventListener("mouseleave", () => isPaused = false);
    animate();  
  }

  if( document.querySelectorAll('.squeeze_scroller_item').length > 0 ){
    const scrollingContent = document.getElementById("scrollingContent");
    scrollingContent.innerHTML += scrollingContent.innerHTML;
    let x = 0;
    let scrollSpeed = 0.4;
    let isPaused = false;
    function animate() {
      if (!isPaused) {
        x -= scrollSpeed;
        if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
          x = 0;
        }
        scrollingContent.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(animate);
    }
    document.querySelector(".squeeze_scroller_main").addEventListener("mouseenter", () => isPaused = true);
    document.querySelector(".squeeze_scroller_main").addEventListener("mouseleave", () => isPaused = false);
    animate();  
  }  

  if( document.querySelectorAll('.timeline-item').length > 0 ){
    const timelineItems = document.querySelectorAll('.timeline-item');
    const progressDots = document.querySelectorAll('.progress-dot');
    const progressBar = document.getElementById('progressBar');
    const progressContainer = document.querySelector('.timeline__outer_container');
    const progressDotsContainer = document.querySelector('.progress-container');
    const paddingStickyElement = getComputedStyle(document.querySelector('.timeline__outer_container'));
    const paddingStickyTop = paddingStickyElement.paddingTop;
    function alignDotsToItems() {
      timelineItems.forEach((item, index) => {
        let offsetTop = 0;
        if (window.innerWidth > 1023) {
          offsetTop = item.offsetTop - paddingStickyTop.replace("px", "");
        } else {
          offsetTop = item.offsetTop;
        }
        if (progressDots[index]) {
          progressDots[index].style.top = `${offsetTop}px`;
        }
      });
      updateProgressBarHeight();
    }
    function updateProgressBarHeight() {
      const activeDots = document.querySelectorAll('.progress-dot.active');
      if (activeDots.length > 0) {
        const firstDotTop = progressDots[0].offsetTop;
        const lastActiveDot = activeDots[activeDots.length - 1];
        const lastDotTop = lastActiveDot.offsetTop;
        progressBar.style.top = `${firstDotTop}px`;
        progressBar.style.height = `${lastDotTop - firstDotTop}px`;
        progressDotsContainer.style.height = `${progressDotsContainer.querySelector('.progress-dots').lastElementChild.offsetTop}px`;
      }
    }
    function setActiveDotByScroll() {
      const viewportMiddle = window.scrollY + window.innerHeight / 2;
      let activeIndex = 0;
      let minDistance = Infinity;
      timelineItems.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemMiddle = itemRect.top + itemRect.height / 2;
        const distance = Math.abs(itemMiddle - window.innerHeight / 2);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });
      timelineItems.forEach((item, index) => {
        item.classList.toggle('center-stage', index === activeIndex);
        progressDots[index]?.classList.toggle('active', index <= activeIndex);
      });
      updateProgressBarHeight();
    }
    progressDots.forEach(dot => dot.style.top = '');
    alignDotsToItems();
    setActiveDotByScroll();
    window.addEventListener('scroll', setActiveDotByScroll);
    window.addEventListener('resize', alignDotsToItems);  
  }
  
})